export default {"src":"/_next/static/media/0xf8a0bf9cf54bb92f17374d9e9a321e6a111a51bd.bc433701.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};